import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.115 3.332a2 2 0 0 1 1.414.586l3.807 3.807a2.273 2.273 0 0 1 0 3.214L8.94 13.334a2.273 2.273 0 0 1-3.215 0L1.92 9.527a2 2 0 0 1-.586-1.414V5.332a2 2 0 0 1 2-2zM4.667 5.999H4.66a.667.667 0 1 0 .478 1.138.667.667 0 0 0-.471-1.138"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.529 3.527a.667.667 0 0 1 .942 0L14 7.055c.727.728 1 1.552 1 2.188 0 .757-.164 1.53-.892 2.257l-1.636 1.637a.667.667 0 0 1-.943-.943l1.062-1.061a2.547 2.547 0 0 0 0-3.602L9.529 4.47a.667.667 0 0 1 0-.943",
      style: {"fill-opacity":".4"}
    }, null, -1)
  ])))
}
export default { render: render }